<template>
    <div class="header-wrapper py-2">
        <button class="timeline-filter-button timeline-filter-updater on-timeline btn btn-primary" :class="[(queueEditActive||timelineUpdating)?'disabled':'']" v-if="isTimelineActive && canUpdateTimeLine" @click="updateTimeline">
            <span>{{ timelineUpdating ? 'Actualizando...' : 'Actualizar' }}</span>
        </button>
        <button class="timeline-filter-button timeline-filter-switcher btn btn-secondary " :class="[isTimelineActive?'on-timeline':'on-filters']" @click="switchTimeline">Cambiar a {{ switchButtonText }}</button>
        <Timeline v-if="isTimelineActive" />
        <Filters v-else></Filters>
    </div>
</template>

<script>
import Timeline from "./Timeline";
import Filters from "./Filters";
import axios from "axios";
import { mapGetters } from "vuex";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";
import EchoEvents from "../../common/echo/echo_events";
import EchoChannels from "../../common/echo/echo_channels";
import PermissionsConsts from "../../common/permissions";

export default {
    name: "ControlProduccionHeader",
    components: {
        Filters,
        Timeline
    },
    data(){
        return {
            isTimelineActive: true,
            timelineUpdating: false
        }
    },
    methods:{
        switchTimeline(){
            this.isTimelineActive = !this.isTimelineActive;
        },
        updateTimeline(){
            this.timelineUpdating = true;
            axios.patch('/api/production-control/update-timeline')
            .then(response => {
                showCustomSuccessSweetAlert('Actualizando información...');
            })
            .catch(error => {
                showCustomErrorSweetAlert(error.response.data);
            }) 
        },
        prepareEchoEvents(){
            window.Echo.private(EchoChannels.PRIVATE.GLOBAL_PRODUCTION)
                .listen(EchoEvents.QUEUE_RECALCULATION_EVENT, () => {
                    this.timelineUpdating = false;
                });
        },
    },
    computed:{
        ...mapGetters(['userHasPermission']),
        ...mapGetters('production_control', ['queueEditActive']),
        switchButtonText(){
            return this.isTimelineActive? 'filtros': 'calendario';
        },
        canUpdateTimeLine(){
            return this.userHasPermission(PermissionsConsts.PLANNER_TIMELINE_UPDATE);
        }
    },
    mounted(){
        this.prepareEchoEvents();
    }
}
</script>